function fetchData(url: string, data: {}, headers:{}) {
    // Create an abort controller to cancel the fetch request
    const controller = new AbortController();
    const signal = controller.signal;
  
    // Return a new promise that fetches data from the URL
    return new Promise((resolve, reject) => {
      // Use fetch API with the signal option and the headers option
      fetch(url, {
        signal,
        headers,
      })
        .then((response) => {
          // Check if the response is ok
          if (response.ok) {
            // Parse the response as JSON and resolve the promise with the data
            return response.json().then((data) => resolve(data));
          } else {
            // Reject the promise with an error message
            reject(new Error(`Fetch failed: ${response.status} ${response.statusText}`));
          }
        })
        .catch((error) => {
          // Reject the promise with an error message
          reject(new Error(`Fetch failed: ${error.message}`));
        })
  
      // If the promise is rejected, abort the fetch request
      .catch(() => controller.abort());
    });
  }
  
  function postData(url: string, data: {}, headers: {}) {
    // Create an abort controller to cancel the fetch request
    const controller = new AbortController();
    const signal = controller.signal;
  
    // Return a new promise that sends a post request to the URL
    return new Promise((resolve, reject) => {
      // Use fetch API with the signal option and the method, headers, and body options
      fetch(url, {
        signal,
        method: "POST",
        // Use Object.assign to merge the headers parameter with the default header
        headers: Object.assign(
          headers
        ),
        body: JSON.stringify(data),
      })
        .then((response) => {
          // Check if the response is ok
          if (response.ok) {
            // Parse the response as JSON and resolve the promise with the data
            return response.json().then((data) => resolve(data));

          } else {
            // Reject the promise with an error message
            reject(new Error(`Post failed: ${response.status} ${response.statusText}`));
          }
        })
        .catch((error) => {
          // Reject the promise with an error message
          reject(new Error(`Post failed: ${error.msg}`));
          console.log(error)
        })
  
      // If the promise is rejected, abort the fetch request
      .catch(() => controller.abort());
    });
  }
    

  
  export { fetchData, postData }

  